import { render, staticRenderFns } from "./AmericanArchitectureAwardForm.vue?vue&type=template&id=17a2891a"
import script from "./AmericanArchitectureAwardForm.vue?vue&type=script&lang=js"
export * from "./AmericanArchitectureAwardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a2891a')) {
      api.createRecord('17a2891a', component.options)
    } else {
      api.reload('17a2891a', component.options)
    }
    module.hot.accept("./AmericanArchitectureAwardForm.vue?vue&type=template&id=17a2891a", function () {
      api.rerender('17a2891a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/american-architecture-award/components/AmericanArchitectureAwardForm.vue"
export default component.exports